module.exports = __webpack_public_path__ + "img/img_5.8a23952d.jpg";